<div class="wrapper" *ngIf="user" >

<div class="bell">
  
    <app-bell class='icon' (notificationClicked)="notificationsClicked.emit()" title="Notifications"  [notificationCount]="notifications" badgeColor="#29b6f6" ></app-bell>
    <app-bell class='icon' (notificationClicked)="prioritiesClicked.emit()"  title="Priorities" *ngIf="priorities > 0" icon="outlined_flag" badgeColor="#e57373"  [notificationCount]="priorities" ></app-bell>
    <app-bell class='icon' (notificationClicked)="chatClicked.emit()"  title="Messages" icon="chat_bubble_outline" badgeColor="#f9a825"  [notificationCount]="chats" ></app-bell>
</div>

<div class="details" (click)="profileClicked.emit()">
    <div class="user">{{ user.name }}</div>
    <div class="roles">
        @for (role of user.roles; track role) {
          <div class="role-badge" [ngStyle]="getBadgeStyle(role)">
            {{role}}
          </div>
        }
    </div>
</div>

<app-avatar (clicked)="profileClicked.emit()" [user]="user" [preview]="previewUserProfile"
[notifications]="0"></app-avatar>

</div>